// This dashboard is deprecated: show a notice and send users to the new one instead of bootstrapping the app.
const NEW_DASHBOARD_URL = 'https://operations.bytescare.com';
let seconds = 5;

document.body.innerHTML = `
  <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:16px;font-family:Inter,sans-serif;background:#f5f6fa;">
    <div style="max-width:480px;width:100%;background:#fff;border-radius:12px;padding:32px;text-align:center;box-shadow:0 4px 24px rgba(0,0,0,.08);">
      <h1 style="font-size:22px;font-weight:600;margin-bottom:12px;">This dashboard has been deprecated</h1>
      <p style="color:#555;margin-bottom:8px;">
        Please use <a href="${NEW_DASHBOARD_URL}">operations.bytescare.com</a> from now on.
      </p>
      <p style="color:#888;margin:0;">Redirecting in <span id="redirect-countdown">${seconds}</span> seconds…</p>
    </div>
  </div>`;

const timer = setInterval(() => {
  seconds--;
  document.getElementById('redirect-countdown').textContent = String(seconds);
  if (seconds <= 0) {
    clearInterval(timer);
    window.location.replace(NEW_DASHBOARD_URL);
  }
}, 1000);
